// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function addError(obj) {
  return { type: types.ERROR_ADD, payload: obj }
}
